var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"C-fragment-cooking-process"},[_c('h2',{staticClass:"C-fragment-cooking-process__header"},[_vm._v(_vm._s(_vm.$t('portal_core.preparation'))+":")]),_vm._v(" "),_c('div',{staticClass:"C-fragment-cooking-process__preparation",domProps:{"innerHTML":_vm._s(_vm.content.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }